import * as React from "react";
import Typography from "@mui/material/Typography";
import { shallowEqual, useSelector } from "react-redux";
import { AuthInfo } from "../../ui/models/authInfo";
import { RootState } from "../../redux";

export default function OrdersPage() {
  const authInfo = useSelector<RootState, AuthInfo>(
    ({ auth }: any) => auth.info,
    shallowEqual
  );

  return (
    <Typography>
      Welcome to the Toolpad orders! {authInfo.userInfo.firstName}
    </Typography>
  );
}
